let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d4HwC")).then(() => parcelRequire('aYsWG'));